module.exports = __webpack_public_path__ + "static/media/Cribis.sk_grey.138d5250.svg";